module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"h1":"Код безопасности","h2":"Deliver отправил код безопасности на номер &plus;{prefix}{number}","h2_2":"Введите код безопасности Deliver, отправленный вам по СМС","enter-number":"Вернуться к вводу номера"}}')
  delete Component.options._Ctor
}
